/**
 * 全局表格单元格溢出 Tooltip 工具
 *
 * 自动检测所有表格 td 单元格，当文字溢出时鼠标悬停显示完整内容
 * 适用于原生 <table> 和 v-data-table
 */

let tooltipEl: HTMLDivElement | null = null

function getTooltipEl(): HTMLDivElement {
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.className = 'cell-ellipsis-tooltip'
    document.body.appendChild(tooltipEl)
  }
  return tooltipEl
}

function hideTooltip() {
  const el = getTooltipEl()
  el.classList.remove('is-visible')
}

function showTooltip(cell: HTMLElement) {
  const text = cell.textContent?.trim() || ''
  if (!text) return

  const el = getTooltipEl()
  el.textContent = text

  const rect = cell.getBoundingClientRect()
  let left = rect.left + rect.width / 2
  let top = rect.top - 8

  if (left - 200 < 0) left = 200
  if (left + 200 > window.innerWidth) left = window.innerWidth - 200
  if (top - 80 < 0) top = rect.bottom + 8

  el.style.left = `${left}px`
  el.style.top = `${top}px`
  el.style.transform = 'translateX(-50%)'

  requestAnimationFrame(() => {
    el.classList.add('is-visible')
  })
}

function isOverflow(el: HTMLElement): boolean {
  return el.scrollWidth > el.clientWidth + 1
}

function handleMouseEnter(e: Event) {
  const td = (e.target as HTMLElement).closest('td') as HTMLElement
  if (!td) return
  if (!isOverflow(td)) return
  showTooltip(td)
}

function handleMouseLeave(e: Event) {
  const td = (e.target as HTMLElement).closest('td') as HTMLElement
  if (!td) return
  hideTooltip()
}

export function setupCellTooltip() {
  document.addEventListener('mouseover', handleMouseEnter)
  document.addEventListener('mouseout', handleMouseLeave)
}
